<template>
    <div class="ProfileImage" :style="style">
        <button class="image-change-button">
            <svgicon class="camera" icon="camerasvg" />
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({ profileImage: 'moduleAuth/avatar' }),

        style() {
            return {
                backgroundImage: `url(${this.profileImage}), url(${this.defaultProfileImage})`
            };
        },

        defaultProfileImage() {
            return require('@/assets/images/profile.png');
        }
    }
};
</script>

<style lang="scss" scoped>
.ProfileImage {
    width: 9em;
    height: 9em;
    border: 0.5em solid white;
    border-radius: 50%;
    position: relative;
    background-size: cover;
    &:after {
        content: '';
        position: absolute;
        top: -0.25em;
        left: -0.25em;
        right: -0.25em;
        bottom: -0.25em;
        border: 1px solid #78e865;
        border-radius: 50%;
    }
    .image-change-button {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 2.5em;
        height: 2.5em;
        background: white;
        z-index: 2;
        border-radius: 50%;
        border: none;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .camera {
            fill: #868686;
            width: 1.1em;
        }
    }
}
</style>
